import { Action, Reducer } from 'redux';

import { ConfigurationState } from './ConfigurationState';
import { CONFIG_LOADED } from './actions';

const INITIAL_STATE: ConfigurationState = {
  data: null,
};

type ConfigurationReducerPayload = any;

export const ConfigurationReducer: Reducer<
  ConfigurationState,
  Action<typeof CONFIG_LOADED> & { payload: ConfigurationReducerPayload }
> = (state = INITIAL_STATE, { type, payload }) => {
  if (type === CONFIG_LOADED) {
    return {
      ...state,
      data: payload,
    };
  }
  return state;
};
